// Predicado único de la regla de oro "sin edificios no se factura".
// Determina si una venta/cuota tiene edificios asignados a partir de su campo CSV de IDs:
// edificios_ids en sales_contratos.meses[], edificiosparticipantes en sales.
// Cubre todos los formatos de "vacío" reales en DB: null | "" | "[]" | "0" | sin ningún id > 0.
export const tieneEdificiosAsignados = (val) => {
  if (val == null) return false;
  return String(val)
    .split(",")
    .map((s) => s.trim())
    .some((s) => Number(s) > 0);
};
